export const PICKER_OPTION_HEIGHT = 40;
export const PICKER_OPTIONS_WRAPPER_HEIGHT = PICKER_OPTION_HEIGHT * 5;
export const PICKER_OPTIONS_WRAPPER_TOP_OFFSET =
  PICKER_OPTIONS_WRAPPER_HEIGHT / 2 - PICKER_OPTION_HEIGHT / 2;
